import { render, staticRenderFns } from "./Previewbooking.vue?vue&type=template&id=32503610&"
import script from "./Previewbooking.vue?vue&type=script&lang=js&"
export * from "./Previewbooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports